import React from 'react';

export const Header = ({ description }) => (
  <h1 id="Order-Details-Text"className="order-summary-header responsive-width">
        { description }
  </h1>
);
